import { Dialog } from 'primereact/dialog'
import React, { FC, useEffect, useState } from 'react'
import { IsNullOrEmptyArray, IsNullOrUndefined, IsStringNullEmptyOrUndefined } from '../../../utils/null-check';
import { AnnotationSolutionListEntity, DrawingPlanPDFEntity } from '../../../interface/pdf-pin';
import { fetchStoredWaltzSolutions } from '../../../service/shared.service';
import { useParams } from 'react-router-dom';
import { SolutionDetails } from '../../../interface/order';
import { SolutionCategoryEnum, StorageKeyEnum } from '../../../utils/enum';
import { Dropdown } from 'primereact/dropdown';
import { usePDFAnnotationStore, useSolutionLinkModelStore } from '../../../store/pdf-pin.store';
import { FINAL_COLOR, LINK_COLOR, svgUrlToPngBytes } from '../utils/pdf-pin.shared';
import Loader from '../../../components/loader';
import { getLocalStorageItem } from '../../../service/storage-service';


interface SolutionLinkModelProp {
    pageDetail: DrawingPlanPDFEntity | null;
}

const SolutionLinkModel: FC<SolutionLinkModelProp> = ({ pageDetail }) => {

    const { orderId }: any = useParams();

    const [isLoading, setIsLoading] = useState(false);

    const [selectedSolution, setSelectedSolution] = useState("");

    const [highlighSystem, setHighlighSystem] = useState("");

    const { selectedHighlight, highlights, setIconCache, updateHighlight, updateHighlightInPage, selectedPageId, setSelectedHighlight, highlightDataSet } = usePDFAnnotationStore()

    const { isOpen, onClose } = useSolutionLinkModelStore()

    const [solutionList, setSolutionList] = useState<AnnotationSolutionListEntity[] | []>([]);

    const [isNewLink, setIsNewLink] = useState(true);

    const handleLinkWithSolution = async () => {
        setIsLoading(true);
        const highlightDetail = highlights.find((item) => item.id === selectedHighlight);
        if (highlightDetail && !IsNullOrUndefined(highlightDetail)) {
            const iconPngBytes: any = await svgUrlToPngBytes(
                highlightDetail.systemIcon,
                LINK_COLOR,
                60,
                60
            );

            // Create image object and wait for load
            const blob = new Blob([iconPngBytes], { type: "image/png" });
            const url = URL.createObjectURL(blob);

            await new Promise<void>((resolve, reject) => {
                const img = new Image();
                img.onload = () => {
                    setIconCache(selectedHighlight, img);
                    resolve();
                };
                img.onerror = reject;
                img.src = url;
            });

            // Update highlights in store and UI
            updateHighlight(selectedHighlight, {
                solutionId: selectedSolution,
                color: LINK_COLOR
            });

            updateHighlightInPage(selectedPageId, selectedHighlight, {
                solutionId: selectedSolution,
                color: LINK_COLOR
            });
            setSelectedHighlight("");
            onClose()
        }
        setIsLoading(false);
        setSelectedSolution("");
    }

    const handleUnLinkWithSolution = async () => {
        setIsLoading(true);
        const highlightDetail = highlights.find((item) => item.id === selectedHighlight);
        if (highlightDetail && !IsNullOrUndefined(highlightDetail)) {
            const iconPngBytes: any = await svgUrlToPngBytes(
                highlightDetail.systemIcon,
                FINAL_COLOR,
                60,
                60
            );

            // Create image object and wait for load
            const blob = new Blob([iconPngBytes], { type: "image/png" });
            const url = URL.createObjectURL(blob);

            await new Promise<void>((resolve, reject) => {
                const img = new Image();
                img.onload = () => {
                    setIconCache(selectedHighlight, img);
                    resolve();
                };
                img.onerror = reject;
                img.src = url;
            });

            // Update highlights in store and UI
            updateHighlight(selectedHighlight, {
                solutionId: "",
                color: FINAL_COLOR
            });

            updateHighlightInPage(selectedPageId, selectedHighlight, {
                solutionId: "",
                color: FINAL_COLOR
            });
            setSelectedHighlight("");
            onClose()
        }
        setIsLoading(false);
        setSelectedSolution("");
    }

    useEffect(() => {

        const waltzOrderDetail = fetchStoredWaltzSolutions(orderId);
        if (waltzOrderDetail && !IsNullOrEmptyArray(waltzOrderDetail)) {

            const storedSolutions: null | SolutionDetails[] | [] = waltzOrderDetail

            if (storedSolutions && !IsNullOrEmptyArray(storedSolutions)) {
                const existingSolutionId: string[] | [] = JSON.parse(getLocalStorageItem(StorageKeyEnum.EXISTING_SOLUTIONS_IDS_FOR_DRAWING_PLAN) || '[]');
                const result = storedSolutions
                    .filter((item) =>
                        !item.isDeleted && item.category === SolutionCategoryEnum.WALTZ && pageDetail
                        && (pageDetail.splitPDFName === item.floor || (existingSolutionId as string[]).includes(item._id)))
                    .map((item) => {
                        if (item.category === SolutionCategoryEnum.WALTZ) {
                            let locationName = [item.solutionNo.toString(), item.floor, item.space, item.systemName].filter((item) => !IsStringNullEmptyOrUndefined(item));
                            return {
                                name: locationName.join("_"),
                                solutionId: item._id,
                                category: item.category,
                                title: [item.solutionNo, item.floor, item.space].join("_"),
                                disabled: false,
                                systemId: item.systemId
                            }
                        }
                    });
                setSolutionList(() => (result as AnnotationSolutionListEntity[]));
            }
        }


        // update selected solution for existing
        const highlightDetail = highlights.find((item) => item.id === selectedHighlight);
        if (highlightDetail && !IsNullOrUndefined(highlightDetail)) {
            setSelectedSolution(highlightDetail.solutionId);
            setHighlighSystem(highlightDetail.systemId)
            setIsNewLink(IsStringNullEmptyOrUndefined(highlightDetail.solutionId));
        } else {

        }


        // disable solution list based on existing highlights
        const highlightDetails = Object.values(highlightDataSet).flatMap(item => item).filter(item => item.id !== selectedHighlight);

        setSolutionList(prevList => {
            return prevList.map(solution => {
                const isDisabled = highlightDetails.some(highlight => highlight.solutionId === solution.solutionId);
                return { ...solution, disabled: isDisabled };
            });
        })
    }, [isOpen, selectedHighlight]);

    return (
        <>
            <Loader isLoading={isLoading} />
            <Dialog visible={isOpen} onHide={onClose} draggable={false} resizable={false} style={{ width: "600px" }} closable={false}>
                <div className="row">
                    <div className="col-12 mb-4">
                        <div className="form-group">
                            <label style={{ fontSize: "14px" }}>
                                SELECT SOLUTION
                            </label>
                            <div>
                                <Dropdown
                                    className='w-100'
                                    value={selectedSolution}
                                    onChange={(e) => setSelectedSolution(e.value)}
                                    options={highlighSystem ? solutionList.filter((item) => item.systemId === highlighSystem) : solutionList}
                                    optionLabel='name'
                                    optionValue='solutionId'
                                    placeholder='Select Solution'
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 ">
                        <div className='d-flex align-items-center justify-content-between'>
                            <div>
                                <button className="btn btn-cancel text-dark m-0" onClick={onClose} >Cancel</button>
                            </div>
                            <div>
                                {
                                    !isNewLink && (
                                        <button className="btn btn-danger text-light m-0" disabled={IsStringNullEmptyOrUndefined(selectedSolution)} onClick={(e) => {
                                            e.stopPropagation()
                                            handleUnLinkWithSolution();
                                            onClose();
                                        }} >Unlink</button>
                                    )
                                }
                                <button className="btn btn-primary mx-2" disabled={IsStringNullEmptyOrUndefined(selectedSolution)} onClick={handleLinkWithSolution}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default SolutionLinkModel